import { render, staticRenderFns } from "./sharedCertificate.vue?vue&type=template&id=74370742&"
import script from "./sharedCertificate.vue?vue&type=script&lang=js&"
export * from "./sharedCertificate.vue?vue&type=script&lang=js&"
import style0 from "./sharedCertificate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports